import { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext({ theme: "light", setTheme: () => {} });

const STORAGE_KEY = "app_theme";

/** Apply a theme by toggling the `dark` class on the document root. */
function applyTheme(theme) {
    if (typeof document === "undefined") return;
    const root = document.documentElement;
    if (theme === "dark") root.classList.add("dark");
    else root.classList.remove("dark");
}

export function ThemeProvider({ children }) {
    const [theme, setThemeState] = useState(() => {
        if (typeof window === "undefined") return "light";
        return window.localStorage.getItem(STORAGE_KEY) || "light";
    });

    // Apply on mount + whenever it changes
    useEffect(() => {
        applyTheme(theme);
        try {
            window.localStorage.setItem(STORAGE_KEY, theme);
        } catch {
            /* localStorage may be disabled in private mode */
        }
    }, [theme]);

    const setTheme = (next) => setThemeState(next === "dark" ? "dark" : "light");
    const toggle = () => setThemeState((t) => (t === "dark" ? "light" : "dark"));

    return (
        <ThemeContext.Provider value={{ theme, setTheme, toggle }}>
            {children}
        </ThemeContext.Provider>
    );
}

export function useTheme() {
    return useContext(ThemeContext);
}
